import type { ClientProfileStatus } from '../../types/case-management'
import { CLIENT_PROFILE_STATUS_LABELS } from '../../types/case-management'

const STATUS_STYLES: Record<ClientProfileStatus, string> = {
  active: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400',
  inactive: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-400',
  archived: 'bg-stone-100 text-stone-800 dark:bg-stone-800 dark:text-stone-400',
}

export function StatusBadge({ status }: { status: ClientProfileStatus }): React.ReactElement {
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${STATUS_STYLES[status]}`}
    >
      {CLIENT_PROFILE_STATUS_LABELS[status]}
    </span>
  )
}
